import { CLOUD, cloudOn, friendlyErr, loadUser, loggedIn } from './api.js';
import { myName } from '../team/team.js';
import { LOCK, LOCK_AFTER, bioName, disableLock, enableLock, lockAvailable, lockCfg, setLockAfter } from './lock.js';
import { cloudSignOut, mfaChallenge, mfaEnroll, mfaUnenroll, mfaVerify, sendRecovery, verifiedFactors } from './auth.js';
import { sbRest } from './api.js';
import { maybeShowAuth } from './authui.js';
import { S, defaultState, persist, setState } from '../state.js';
import { openAuth, otpBox } from './authui.js';
import { cloudCheck, cloudPush, setStatus, stopPolling, syncPersistLS } from './sync.js';
import { t } from '../i18n/index.js';
import { IC, RT, ask, closeSheet, esc, render, sheet, toast } from '../ui.js';
import { plan } from './plan.js';
import { openProfileMenu } from '../menu.js';
import { openSettings } from '../views/settings.js';
import { LEGAL } from '../legal.js';
const planBadge=()=>{if(!loggedIn()||!CLOUD.ctx)return '';const p=plan();return p&&p!=='free'?'<span class="planbadge">'+(p==='pro'?'PRO':'TEAM')+'</span>':''};

export function acctInitials(){
  const a=CLOUD.auth;
  if(!a)return '?';
  const n=(a.name||'').trim();
  if(n)return n.split(/\s+/).slice(0,2).map(x=>x[0]).join('').toUpperCase();
  return (a.email||'?').slice(0,2).toUpperCase();
}
export function updateAccountUI(){
  document.querySelectorAll('[data-account]').forEach(b=>{
    b.style.display='';
    const li=loggedIn();
    const av=li?(CLOUD.auth.pic?'<img src="'+esc(CLOUD.auth.pic)+'" alt="" referrerpolicy="no-referrer">':'<span class="acctini">'+esc(acctInitials())+'</span>'):'<span class="acctini out">'+IC.user+'</span>';
    if(b.dataset.variant==='row'){
      const nm=li?(CLOUD.auth.name||myName()||CLOUD.auth.email):(S.settings.teacher||t('pm.local'));
      const sub=li?CLOUD.auth.email:t('pm.localHint');
      b.innerHTML='<span class="pr-av">'+av+(li?planBadge():'')+'</span><span class="pr-txt"><b>'+esc(nm||'')+'</b><small>'+esc(sub||'')+'</small></span><span class="pr-chev" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M8 10l4-4 4 4M8 14l4 4 4-4"/></svg></span>';
    }else b.innerHTML=av+(li?planBadge():'');
    b.setAttribute('aria-haspopup','menu');b.setAttribute('aria-label',t('pm.title'));
    b.onclick=e=>{e.stopPropagation();openProfileMenu(b)};
  });
}
export function openAccount(){
  const a=CLOUD.auth;
  const factors=verifiedFactors();
  const b=sheet('<div class="sheethead"><h2>'+t('acct.title')+'</h2><button class="iconbtn" data-a="x">'+IC.x+'</button></div>'+
  '<div class="sheetbody">'+
    '<div class="acctrow">'+
      '<div class="acctav">'+(a.pic?'<img src="'+esc(a.pic)+'" alt="" referrerpolicy="no-referrer">':esc(acctInitials()))+'</div>'+
      '<div class="grow"><div style="font-weight:680;font-size:15px">'+esc(a.name||a.email)+'</div>'+
      '<div class="meta">'+esc(a.email)+'</div></div>'+
      '<span class="syncbadge" data-sync></span>'+
    '</div>'+
    '<div class="syncerr" data-syncerr hidden><b>'+t('cloud.errTitle')+'</b><span class="se-msg"></span><button class="btn small" data-a="resync">'+t('cloud.retry')+'</button></div>'+
    '<div class="divider"></div>'+
    '<div class="eyebrow mb8">'+t('acct.security')+'</div>'+
    '<div class="card" style="padding:15px;box-shadow:none">'+
      '<div class="row between">'+
        '<div style="min-width:0"><div style="font-weight:650;font-size:13.5px">'+t('acct.mfa')+'</div>'+
        '<div class="tiny">'+(factors.length?t('acct.mfaOn'):t('acct.mfaOff'))+'</div></div>'+
        (factors.length
          ?'<button class="btn small danger" data-a="mfaoff">'+t('acct.mfaRemove')+'</button>'
          :'<button class="btn small primary" data-a="mfaon">'+t('acct.mfaAdd')+'</button>')+
      '</div>'+
      '<div class="divider" style="margin:13px 0"></div>'+
      '<div class="row between">'+
        '<div><div style="font-weight:650;font-size:13.5px">'+t('acct.pw')+'</div><div class="tiny">'+t('acct.pwHint')+'</div></div>'+
        '<button class="btn small" data-a="pwreset">'+t('acct.pwChange')+'</button>'+
      '</div>'+
    '</div>'+
  '</div>'+
  '<div class="sheetfoot"><div class="left"><button class="linkbtn dellink" data-a="del">'+t('acct.delete')+'</button></div>'+
  '<button class="btn" data-a="out">'+t('cloud.out')+'</button></div>');
  const q=x=>b.querySelector(x);
  setStatus(CLOUD.status);
  q('[data-a=x]').onclick=()=>closeSheet(b);
  q('[data-a=resync]').onclick=async()=>{setStatus('saving');try{if(CLOUD.dirty)await cloudPush();else await cloudCheck(true)}catch(e){}};
  if(CLOUD.status==='error')(CLOUD.dirty?cloudPush():cloudCheck(true)).catch(()=>{});
  q('[data-a=out]').onclick=()=>{closeSheet(b);cloudSignOut()};
  q('[data-a=del]').onclick=()=>{closeSheet(b);openDeleteAccount()};
  q('[data-a=pwreset]').onclick=async()=>{try{await sendRecovery(a.email);toast(t('auth.resetSent'))}catch(e){toast(friendlyErr(e.message))}};
  if(q('[data-a=mfaon]'))q('[data-a=mfaon]').onclick=()=>{closeSheet(b);openMfaSetup()};
  if(q('[data-a=mfaoff]'))q('[data-a=mfaoff]').onclick=()=>ask(t('acct.mfaRemoveAsk'),async()=>{
    try{await mfaUnenroll(factors[0].id);await loadUser();closeSheet(b);toast(t('acct.mfaRemoved'))}catch(e){toast(friendlyErr(e.message))}
  },true);
}
export async function openMfaSetup(){
  let enroll;
  try{enroll=await mfaEnroll()}catch(e){toast(friendlyErr(e.message));return}
  const uri=(enroll.totp&&enroll.totp.uri)||'';
  const secret=(enroll.totp&&enroll.totp.secret)||'';
  const b=sheet('<div class="sheethead"><h2>'+t('acct.mfaAdd')+'</h2><button class="iconbtn" data-a="x">'+IC.x+'</button></div>'+
  '<div class="sheetbody">'+
    '<p class="muted mb">'+t('acct.mfaStep1')+'</p>'+
    '<div class="qrbox"><img id="mf-qr" alt="" width="190" height="190"></div>'+
    '<p class="tiny mt" style="text-align:center">'+t('acct.mfaManual')+'</p>'+
    '<div class="secretbox" id="mf-sec">'+esc(secret)+'</div>'+
    '<div class="divider"></div>'+
    '<p class="muted mb8">'+t('acct.mfaStep2')+'</p>'+
    otpBox('mf-code')+
    '<div class="autherr" id="mf-err" style="display:none"></div>'+
  '</div>'+
  '<div class="sheetfoot"><button class="btn" data-a="cancel">'+t('c.cancel')+'</button><button class="btn primary" data-a="ok">'+t('acct.mfaConfirm')+'</button></div>');
  const q=x=>b.querySelector(x);
  import('qrcode').then(Q=>(Q.default||Q).toDataURL(uri,{margin:1,width:380,color:{dark:'#1B1C22',light:'#FFFFFF'}})).then(u=>{const im=q('#mf-qr');if(im)im.src=u}).catch(()=>{});
  const inp=q('#mf-code');inp.focus();
  inp.oninput=()=>{inp.value=inp.value.replace(/\D/g,'').slice(0,6)};
  q('#mf-sec').onclick=()=>{const ta=document.createElement('textarea');ta.value=secret;document.body.appendChild(ta);ta.select();try{document.execCommand('copy')}catch(e){}ta.remove();toast(t('c.copied'))};
  const cancel=async()=>{try{await mfaUnenroll(enroll.id)}catch(e){}closeSheet(b)};
  q('[data-a=x]').onclick=cancel;q('[data-a=cancel]').onclick=cancel;
  q('[data-a=ok]').onclick=async()=>{
    const code=inp.value.trim();const err=q('#mf-err');
    if(code.length!==6){err.style.display='';err.textContent=t('auth.eCode');return}
    try{
      const ch=await mfaChallenge(enroll.id);
      await mfaVerify(enroll.id,ch.id,code);
      await loadUser();closeSheet(b);toast(t('acct.mfaDone'));
      if(RT.v==='settings')render();
    }catch(e){err.style.display='';err.textContent=friendlyErr(e.message)}
  };
}

/* ================= settings card ================= */
export function cloudCard(){
  if(!cloudOn())return '<div class="card mb marge"><div class="cardhead"><h2>'+t('cloud.title')+'</h2></div>'+
    '<p class="muted mb8" style="font-size:13px">'+t('cloud.hint')+'</p>'+
    '<button class="btn primary" data-ca="setup">'+IC.cloud+' '+t('cloud.connect')+'</button></div>';
  if(!loggedIn())return '<div class="card mb marge"><div class="cardhead"><h2>'+t('cloud.title')+'</h2></div>'+
    '<p class="muted mb8" style="font-size:13px">'+t('cloud.signedOut')+'</p>'+
    '<div class="row"><button class="btn primary" data-ca="login">'+t('cloud.signin')+'</button>'+
    (CLOUD.cfg.baked?'':'<button class="btn small ghost" data-ca="disc">'+t('cloud.disc')+'</button>')+'</div></div>';
  const f=verifiedFactors();
  return '<div class="card mb"><div class="cardhead"><h2>'+t('cloud.title')+'</h2><span class="syncbadge" data-sync></span></div>'+
    '<p class="muted mb8" style="font-size:13px">'+esc(t('cloud.in',{e:CLOUD.auth.email||''}))+
    (f.length?' · <span style="color:var(--ok)">'+t('acct.mfaOn')+'</span>':'')+'</p>'+
    '<div class="row"><button class="btn small primary" data-ca="acct">'+t('acct.title')+'</button>'+
    '<button class="btn small" data-ca="out">'+t('cloud.out')+'</button></div>'+
    '<p class="tiny mt">'+t('set.about')+'</p></div>';
}
export function cloudAction(a){
  if(a==='setup')openAuth('setup');
  else if(a==='login')openAuth('login');
  else if(a==='acct')openSettings('account');
  else if(a==='out')cloudSignOut();
  else if(a==='disc')ask(t('cloud.discConfirm'),()=>{
    clearTimeout(CLOUD.t);stopPolling();CLOUD.cfg=null;CLOUD.auth=null;CLOUD.user=null;CLOUD.rev=null;CLOUD.dirty=false;syncPersistLS();
    localStorage.removeItem('plume.cloud');localStorage.removeItem('plume.auth');localStorage.removeItem('plume.mode');
    setStatus('off');updateAccountUI();if(RT.v==='settings')render();
  },true);
}

/* ================= boot ================= */

/* Delete the account: typed confirmation with the user's own email, like GitHub or Linear. */
function openDeleteAccount(){
  const email=(CLOUD.auth&&CLOUD.auth.email)||'';
  const b=sheet(`<div class="sheethead"><h2>${t('acct.delTitle')}</h2><button class="iconbtn" data-x aria-label="${esc(t('c.close'))}">${IC.x}</button></div>
  <div class="sheetbody">
    <p>${t('acct.delText')}</p>
    <ul class="dellist"><li>${t('acct.del1')}</li><li>${t('acct.del2')}</li><li>${t('acct.del3')}</li></ul>
    <p class="tiny mb8">${t('acct.delExport')}</p>
    <label class="field"><span>${t('acct.delType',{e:'<b>'+esc(email)+'</b>'})}</span><input class="input" id="del-e" type="email" autocomplete="off" spellcheck="false"></label>
    <p class="fielderr" id="del-err" hidden></p>
  </div>
  <div class="sheetfoot"><button class="btn" data-x>${t('c.cancel')}</button><button class="btn danger" data-go disabled>${t('acct.delGo')}</button></div>`);
  const go=b.querySelector('[data-go]'),inp=b.querySelector('#del-e'),err=b.querySelector('#del-err');
  b.querySelectorAll('[data-x]').forEach(x=>x.onclick=()=>closeSheet(b));
  inp.oninput=()=>{go.disabled=inp.value.trim().toLowerCase()!==email.toLowerCase()};
  go.onclick=async()=>{
    go.disabled=true;go.classList.add('busy');err.hidden=true;
    try{
      const r=await sbRest('rpc/delete_my_account',{method:'POST',body:'{}'}).catch(async e=>{throw e});
      void r;
      closeSheet(b);cloudSignOut(true);setState(defaultState());persist();
      maybeShowAuth({notice:t('acct.delDone')});
    }catch(e){
      go.classList.remove('busy');go.disabled=false;
      err.textContent=/team_owner/.test(String(e.message))?t('team.e.team_owner'):/active_subscription/.test(String(e.message))?t('acct.delSub'):t('acct.delErr');err.hidden=false;
    }
  };
  setTimeout(()=>inp.focus(),80);
}

/* ---------- Settings → Konto & Sicherheit ---------- */
export function accountPane(){
  if(!cloudOn()||!loggedIn())return cloudCard();
  const a=CLOUD.auth,f=verifiedFactors();
  return `<div class="card mb"><div class="acctrow">
      <div class="acctav">${a.pic?'<img src="'+esc(a.pic)+'" alt="" referrerpolicy="no-referrer">':esc(acctInitials())}</div>
      <div class="grow" style="min-width:0"><div style="font-weight:680;font-size:15px">${esc(a.name||a.email)}</div><div class="meta">${esc(a.email)}</div></div>
      <span class="syncbadge" data-sync></span></div>
    <div class="syncerr" data-syncerr hidden><b>${t('cloud.errTitle')}</b><span class="se-msg"></span><button class="btn small" data-a="resync">${t('cloud.retry')}</button></div>
  </div>
  <div class="card mb"><h3 class="cardsub">${t('acct.security')}</h3>
    <div class="setrow"><div class="grow"><b>${t('acct.mfa')}</b><small>${f.length?t('acct.mfaOn'):t('acct.mfaOff')}</small></div>
      ${f.length?`<button class="btn small" data-a="mfaoff">${t('acct.mfaRemove')}</button>`:`<button class="btn small primary" data-a="mfaon">${t('acct.mfaAdd')}</button>`}</div>
    ${lockRows()}
    <div class="setrow"><div class="grow"><b>${t('sec.row')}</b><small>${t('sec.rowHint')}</small></div><button class="btn small" data-a="secure">${t('sec.rowBtn')}</button></div>
    <div class="setrow"><div class="grow"><b>${t('acct.pw')}</b><small>${t('acct.pwHint')}</small></div><button class="btn small" data-a="pwreset">${t('acct.pwChange')}</button></div>
  </div>
  <div class="card mb"><h3 class="cardsub">${t('lg.docs')}</h3>
    <div class="setrow"><div class="grow"><b>${t('lg.dpa')}</b><small>${t('lg.dpaHint')}</small></div><a class="btn small" href="${LEGAL.dpaPdf}" target="_blank" rel="noopener" download>${IC.dl} PDF</a></div>
    <div class="legallinks"><a href="${LEGAL.terms}" target="_blank" rel="noopener">${t('lg.terms')}</a><a href="${LEGAL.privacy}" target="_blank" rel="noopener">${t('lg.privacy')}</a><a href="${LEGAL.dpa}" target="_blank" rel="noopener">${t('lg.dpaShort')}</a><a href="${LEGAL.imprint}" target="_blank" rel="noopener">${t('lg.imprint')}</a></div>
  </div>
  <div class="card"><div class="setrow"><div class="grow"><b>${t('cloud.out')}</b><small>${t('acct.outHint')}</small></div><button class="btn small" data-a="out">${t('cloud.out')}</button></div>
    <div class="setrow"><div class="grow"><b>${t('acct.delete')}</b><small>${t('acct.delHint')}</small></div><button class="btn small ghost dellink" data-a="del">${t('acct.delete')}</button></div>
  </div>`;
}
export function bindAccountPane(m){
  const p=m.querySelector('[data-pane=account]');if(!p||!loggedIn())return;
  const q=x=>p.querySelector(x);
  setStatus(CLOUD.status);
  const rs=q('[data-a=resync]');if(rs)rs.onclick=async()=>{setStatus('saving');try{if(CLOUD.dirty)await cloudPush();else await cloudCheck(true)}catch(e){}};
  if(CLOUD.status==='error')(CLOUD.dirty?cloudPush():cloudCheck(true)).catch(()=>{});
  q('[data-a=out]').onclick=()=>cloudSignOut();
  q('[data-a=del]').onclick=()=>openDeleteAccount();
  q('[data-a=pwreset]').onclick=async()=>{try{await sendRecovery(CLOUD.auth.email);toast(t('auth.resetSent'))}catch(e){toast(friendlyErr(e.message))}};
  if(q('[data-a=mfaon]'))q('[data-a=mfaon]').onclick=()=>openMfaSetup();
  if(q('[data-a=mfaoff]'))q('[data-a=mfaoff]').onclick=()=>ask(t('acct.mfaRemoveAsk'),async()=>{
    try{await mfaUnenroll(verifiedFactors()[0].id);await loadUser();render();toast(t('acct.mfaRemoved'))}catch(e){toast(friendlyErr(e.message))}
  },true);
  if(q('[data-a=secure]'))q('[data-a=secure]').onclick=()=>import('./devices.js').then(m=>m.openSecureSheet());
  const lon=q('[data-a=lockon]');
  if(lon)lon.onclick=()=>{const run=enableLock();lon.disabled=true;lon.classList.add('busy');run.then(ok=>{if(ok){render();toast(t('lock.done',{m:bioName()}))}else{lon.disabled=false;lon.classList.remove('busy')}})};
  if(q('[data-a=lockoff]'))q('[data-a=lockoff]').onclick=()=>ask(t('lock.offAsk'),()=>{disableLock();render();toast(t('lock.removed'))},true);
  if(q('#lock-after'))q('#lock-after').onchange=e=>{setLockAfter(e.target.value);toast(t('lock.saved'))};
  if(LOCK.avail===null)lockAvailable().then(()=>{if(LOCK.avail&&q('[data-lockrow]'))render()});
}
/* App-Sperre: one row, plus "lock after" once it is on */
function lockRows(){
  const c=lockCfg(),m=bioName();
  if(LOCK.avail===false&&!c)return `<div class="setrow" data-lockrow><div class="grow"><b>${t('lock.title')}</b><small>${t('lock.na')}</small></div></div>`;
  if(!c)return `<div class="setrow" data-lockrow><div class="grow"><b>${t('lock.title')}</b><small>${esc(t('lock.hint',{m}))}</small></div><button class="btn small primary" data-a="lockon">${t('lock.enable')}</button></div>`;
  return `<div class="setrow" data-lockrow><div class="grow"><b>${t('lock.title')}</b><small><span style="color:var(--ok)">${esc(t('lock.active',{m}))}</span> · ${t('lock.device')}</small></div><button class="btn small" data-a="lockoff">${t('lock.disable')}</button></div>
    <div class="setrow"><div class="grow"><b>${t('lock.after')}</b><small>${t('lock.afterHint')}</small></div>
      <select class="input lockafter" id="lock-after">${LOCK_AFTER.map(n=>`<option value="${n}" ${(c.after||0)===n?'selected':''}>${n?t('lock.min',{n}):t('lock.now')}</option>`).join('')}</select></div>`;
}
